import type { IComponentController, IScope } from "angular";
import "angular-translate";
import { maxBy as lodashMaxBy } from "lodash";
import moment from "moment-timezone";

import type { IEventReport, IResponseWithLoading } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";
import { finalize } from "rxjs/operators";

export default class LatestEventsComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$translate", "mmSitesRepository"];

    public caption: string;

    public eventReports: IResponseWithLoading<IEventReport[]>;

    public timeSinceLastReport: string;

    public siteId: string;

    public subCaption: string;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        this.caption = "Entities.EventReport.EventReports";

        const dtFrom = moment.utc().subtract(7, "days").format();
        const dtTo = moment.utc().format();

        extendWithLoadingAndFail(this.sitesRepository.getEventReportsForSite(this.siteId, dtFrom, dtTo))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe((eventReportsResponse) => {
                this.eventReports = eventReportsResponse;

                if (this.eventReports.isLoading) {
                    return;
                }

                const lastReport = lodashMaxBy(this.eventReports.data, (report) => report.dtSent);

                if (lastReport) {
                    this.timeSinceLastReport = lastReport.dtSent.fromNow(true);
                    this.subCaption = this.$translate.instant("Entities.Site.LastEventReport");
                }

                this.caption = this.$translate.instant(
                    "Entities.EventReport.NumEventReportsLastWeekFormat",
                    { numEventReports: this.eventReports.data.length },
                    "messageformat",
                );
            });
    }
}
